// 단계적 시작에서 환경을 미리 준비(예열)할 지역1 스테이지 지도를 고르는 순수 함수(three 없음). render/index.ts가 쓰고 시험한다.
// 지역1 스테이지는 A·A′·M·B·B′·F 여섯 장의 서로 다른 지도 객체를 쓰고(env 캐시 키 = MapDef 객체), MAPS.r1(= A)만 예열하면
// 3·4·5·6~10 스테이지 첫 입장 때 환경 준비가 렌더 루프에서야 시작돼 그레이박스·컴파일 끊김이 보인다(PR #175 4차 리뷰 P2).
import { parseAnyStage, stagePlan, stageIdOf } from '../../shared/content/stages';
import { REGION_IDS, type MapDef } from '../../shared/levels';
import { getStageMaps } from '../../shared/stageMaps';

/** 진행 뷰에서 읽는 것만(최전선·고른 스테이지) */
export interface WarmSource {
  readonly frontier?: string;
  selected(region: 'r1' | 'r2'): string | null;
}

/**
 * 입장할 지도 = 이 스테이지(노말 r…·하드 h…)의 판 계획 지도. 하드도 같은 노말 지도를 쓴다.
 * 스테이지 지도가 없는 지역(3·4)이면 null(지역 지도 하나뿐이라 따로 예열할 것이 없다). 지역2(S6)도 지역1처럼 6장
 */
export function stageEntryMap(id: string | null): MapDef | null {
  const p = id ? parseAnyStage(id) : null;
  if (!p || !getStageMaps()[REGION_IDS[p.region - 1]]) return null;
  return stagePlan(stageIdOf(p.region, p.index)).map;
}

/**
 * 예열할 스테이지 지도(중복 없이, 순서 = 최전선 → 고른 노말 → 고른 하드, 지역1 다음 지역2).
 * 대표님이 지금 들어갈 가능성이 큰 스테이지(최전선·문 앞에서 고른 스테이지)의 지도다.
 */
export function stageMapsToWarm(progress: WarmSource | undefined, hard: WarmSource | undefined): MapDef[] {
  const out: MapDef[] = [];
  for (const id of [progress?.frontier ?? null, progress?.selected('r1') ?? null, hard?.selected('r1') ?? null, progress?.selected('r2') ?? null, hard?.selected('r2') ?? null]) {
    const m = stageEntryMap(id);
    if (m && !out.includes(m)) out.push(m);
  }
  return out;
}
